import { createFileRoute } from '@tanstack/react-router';

import { parseEditorSearch } from '../../entities/flow';

// Component only in the `.lazy.tsx` sibling: it pulls in xyflow through the flow-kit
// canvas, the same split `dev/flow-kit` uses so the Flows list does not pay for it.
export const Route = createFileRoute('/_shell/flows/$flowId')({
  validateSearch: parseEditorSearch,
});
